import { SearchClient as TypesenseSearchClient } from 'typesense'

const PER_PAGE = 24

function initializeTypesenseClient(config) {
  return new TypesenseSearchClient({
    nodes: [
      {
        host: config.typesenseHost,
        port: '443',
        protocol: 'https',
      },
    ],
    apiKey: config.typesenseApiKey,
    connectionTimeoutSeconds: 2,
  })
}

async function searchProductsByQuery(
  typesenseClient,
  config,
  query,
  category,
  page,
  storeCode
) {
  const typesenseSearchParameters = {
    q: query,
    page: page + 1,
    preset: 'v4',
    filter_by: `_tags:=${storeCode} && _tags:=shoppable`,
    per_page: PER_PAGE,
  }

  if (category !== '') {
    typesenseSearchParameters.filter_by += ` && product_type_code:=${category}`
  }

  const typesenseResult = await typesenseClient
    .collections(config.typesenseCollectionPath)
    .documents()
    .search(typesenseSearchParameters)

  return typesenseResult
}

function extractFiltersFromFacetCounts(facetCounts) {
  const filters = facetCounts?.reduce(
    (acc, count) => ({ ...acc, [count?.value]: count?.count }),
    {}
  )

  return filters
}

function buildSearchResultVariables(typesenseResult) {
  const { hits, found: totalDocumentsFound } = typesenseResult
  let { page: currentPage } = typesenseResult
  currentPage -= 1
  const filters = extractFiltersFromFacetCounts(
    // eslint-disable-next-line camelcase
    typesenseResult?.facet_counts?.[0]?.counts
  )
  const totalPages = Math.floor(totalDocumentsFound / PER_PAGE)

  return {
    hits,
    currentPage,
    filters,
    totalPages,
  }
}

export {
  initializeTypesenseClient,
  searchProductsByQuery,
  extractFiltersFromFacetCounts,
  buildSearchResultVariables,
}
